import { render, staticRenderFns } from "./SafetyRisk.vue?vue&type=template&id=7c55ce89&"
import script from "./SafetyRisk.vue?vue&type=script&lang=js&"
export * from "./SafetyRisk.vue?vue&type=script&lang=js&"
import style0 from "./SafetyRisk.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports